import { useState } from 'react';
import { useFavouritesQuery, useSetFavouriteMutation } from '@platform/state/api';

/**
 * Обране для запису (прототип v4, «Обране» на панелі дій): стан — зі списку GET /me/favourites, перемикання — PUT/DELETE
 * /me/favourites/{id} з миттєвим відгуком кнопки (оптимістично; невдача повертає попередній стан).
 */
export function useFavourite(recordId: string): { on: boolean; busy: boolean; toggle: () => void } {
  const { data } = useFavouritesQuery(undefined, { skip: !recordId });
  const [setFavourite, { isLoading }] = useSetFavouriteMutation();
  const [pending, setPending] = useState<boolean | null>(null);
  const saved = Boolean(data?.some((f) => f.recordId === recordId));
  const on = pending ?? saved;
  const toggle = () => {
    const next = !on;
    setPending(next);
    void setFavourite({ recordId, on: next }).unwrap().catch(() => undefined).finally(() => setPending(null));
  };
  return { on, busy: isLoading, toggle };
}
